// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__Yzy_4","text":"tooltip_text__o0NLL"};